import { takeLatest, all, takeEvery } from "redux-saga/effects";
import * as authSagas from "../modules/login/redux/sagas/handleAuth";
import * as authConstants from "../modules/login/redux/constants";
import * as labSetupSagas from "../modules/LabSetup/redux/sagas/handleLabsSetupManager";
import * as labSetupConstants from "../modules/LabSetup/redux/constants";
import * as labsStockManagementSagas from "../modules/LabsStockManagement/redux/sagas/labSagas";
import * as labsStockManagementConstants from "../modules/LabsStockManagement/redux/constants";
import * as departmentsConstants from "../modules/ActivityTypes/redux/constants";
import * as departments from "../modules/ActivityTypes/redux/sagas/handleActivityTypes";
import * as constants from "../modules/UserManager/redux/constants";
import * as usersManager from "../modules/UserManager/redux/sagas/handleUserManager";
import * as labStatuses from "../modules/LabStatuses/redux/sagas/handleActivityTypes";
import * as labStatusesConstants from "../modules/LabStatuses/redux/constants";
import * as varianceStatuses from "../modules/VarianceStatuses/redux/sagas/handleActivityTypes";
import * as varianceStatusesConstants from "../modules/VarianceStatuses/redux/constants";
import * as dashboardSagas from "../modules/Dashboard/redux/sagas/dashboardSagas";
import * as dashboardConstants from "../modules/Dashboard/redux/constants";


function* watcherSaga() {
  yield takeEvery(authConstants.LOGIN, authSagas.handleLoginUser);
  yield takeLatest(authConstants.LOGOUT, authSagas.handleLogoutUser);
  yield takeLatest(authConstants.FETCH_SIDEBAR_LABS, authSagas.handleFetchSidebarLabs);
  yield takeLatest(constants.FETCH_USER, usersManager.handleFetchUser);
  yield takeLatest(constants.FETCH_ALL_USERS, usersManager.handleFetchAllUsers);
  yield takeLatest(constants.DELETE_USER, usersManager.handleDeleteUser);
  yield takeLatest(constants.UPDATE_USER, usersManager.handleUpdateUser);
  yield takeLatest(constants.UPDATE_USER_PERMISSIONS, usersManager.handleUpdateUserPermissions);
  yield takeLatest(constants.UPDATE_USER_SETTINGS, usersManager.handleUpdateUserSettings);
  yield takeLatest(constants.CREATE_USER, usersManager.handleCreateUser);
  yield takeLatest(constants.CREATE_USER_LAB, usersManager.handleCreateUserLab);
  yield takeLatest(constants.UPDATE_USER_LAB, usersManager.handleUpdateUserLab);
  yield takeLatest(constants.DELETE_USER_LAB, usersManager.handleDeleteUserLab);
  yield takeLatest(constants.FETCH_ALL_USER_LABS, usersManager.handleFetchAllUserLabs);
  yield takeLatest(constants.SEND_DETAILS_TO_USER, usersManager.handleSendDetailsToUser);
  yield takeLatest(
    departmentsConstants.FETCH_DEPARTMENTS,
    departments.handleFetchDepartments
  );
  yield takeEvery(
    departmentsConstants.UPDATE_DEPARTMENTS,
    departments.handleUpdateDepartment
  );
  yield takeEvery(
    departmentsConstants.DELETE_DEPARTMENTS,
    departments.handleDeleteDepartments
  );
  yield takeEvery(
    departmentsConstants.CREATE_DEPARTMENTS,
    departments.handleCreateDepartment
  );
  yield takeLatest(
    labStatusesConstants.FETCH_LAB_STATUSES,
    labStatuses.handleFetchLabStatuses
  );
  yield takeLatest(
    labStatusesConstants.UPDATE_LAB_STATUSES,
    labStatuses.handleUpdateLabStatuses
  );
  yield takeLatest(
    labStatusesConstants.DELETE_LAB_STATUSES,
    labStatuses.handleDeleteLabStatuses
  );
  yield takeLatest(
    labStatusesConstants.CREATE_LAB_STATUSES,
    labStatuses.handleCreateLabStatuses
  );
  yield takeLatest(
    labStatusesConstants.UPDATE_ORDER,
    labStatuses.handleUpdateLabOrder
  );
  yield takeLatest(
    varianceStatusesConstants.FETCH_VARIANCE_STATUSES,
    varianceStatuses.handleFetchVarianceStatuses
  );
  yield takeLatest(
    varianceStatusesConstants.UPDATE_VARIANCE_STATUSES,
    varianceStatuses.handleUpdateVarianceStatuses
  );
  yield takeLatest(
    varianceStatusesConstants.DELETE_VARIANCE_STATUSES,
    varianceStatuses.handleDeleteVarianceStatuses
  );
  yield takeLatest(
    varianceStatusesConstants.CREATE_VARIANCE_STATUSES,
    varianceStatuses.handleCreateVarianceStatuses
  );
  yield takeLatest(
    varianceStatusesConstants.UPDATE_ORDER,
    varianceStatuses.handleUpdateVarianceOrder
  );
  yield takeLatest(
    varianceStatusesConstants.SET_COMPLETED_STATUS,
    varianceStatuses.handleSetCompletedStatus
  );
  yield takeLatest(
    labSetupConstants.FETCH_ALL_LABS,
    labSetupSagas.handleFetchAllLabs
  );
  yield takeLatest(
    labSetupConstants.UPDATE_LAB,
    labSetupSagas.handleUpdateLab
  );
  yield takeLatest(
    labSetupConstants.DELETE_LAB,
    labSetupSagas.handleDeleteLab
  );
  yield takeLatest(
    labSetupConstants.CREATE_LAB,
    labSetupSagas.handleCreateLab
  );
  yield takeLatest(
    labSetupConstants.FETCH_LAB,
    labSetupSagas.handleFetchLab
  );
  yield takeLatest(
    labSetupConstants.DELETE_LAB_ATTACH,
    labSetupSagas.handleDeleteLabAttach
  );
  // yield takeLatest(
  //   labSetupConstants.UPDATE_LAB_NOTIFICATIONS,
  //   labSetupSagas.handleUpdateLabNotifications
  // );
  yield takeLatest(
    labSetupConstants.DELETE_STOCK_NOTIFICATION_RECIPIENT,
    labSetupSagas.handleDeleteStockNotificationRecipient
  );
  yield takeLatest(
    labSetupConstants.FETCH_LAB_USERS,
    labSetupSagas.handleFetchLabUsers
  );

  yield takeLatest(
    labSetupConstants.FETCH_LAB_USERS_MAP,
    labSetupSagas.handleFetchLabUsersMap
  );

  yield takeLatest(
    labSetupConstants.FETCH_WAREHOUSES,
    labSetupSagas.handleFetchWarehouses
  );

  // Stock Management Register Sagas
  yield takeLatest(
    labsStockManagementConstants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS,
    labsStockManagementSagas.handleFetchAllStockManagementRegisters
  );
  yield takeLatest(
    labsStockManagementConstants.FETCH_STOCK_MANAGEMENT_REGISTER,
    labsStockManagementSagas.handleFetchStockManagementRegister
  );
  yield takeLatest(
    labsStockManagementConstants.CREATE_STOCK_MANAGEMENT_REGISTER,
    labsStockManagementSagas.handleCreateStockManagementRegister
  );
  yield takeLatest(
    labsStockManagementConstants.UPDATE_STOCK_MANAGEMENT_REGISTER,
    labsStockManagementSagas.handleUpdateStockManagementRegister
  );
  yield takeLatest(
    labsStockManagementConstants.DELETE_STOCK_MANAGEMENT_REGISTER,
    labsStockManagementSagas.handleDeleteStockManagementRegister
  );

  // Stock Take Sagas
  yield takeLatest(
    labsStockManagementConstants.FETCH_ALL_STOCK_TAKES,
    labsStockManagementSagas.handleFetchAllStockTakes
  );
  yield takeLatest(
    labsStockManagementConstants.CREATE_STOCK_TAKE,
    labsStockManagementSagas.handleCreateStockTake
  );
  yield takeLatest(
    labsStockManagementConstants.UPDATE_STOCK_TAKE,
    labsStockManagementSagas.handleUpdateStockTake
  );
  yield takeLatest(
    labsStockManagementConstants.DELETE_STOCK_TAKE,
    labsStockManagementSagas.handleDeleteStockTake
  );

  // Variance Report Sagas
  yield takeLatest(
    labsStockManagementConstants.GENERATE_VARIANCE_REPORT,
    labsStockManagementSagas.handleGenerateVarianceReport
  );
  yield takeLatest(
    labsStockManagementConstants.FETCH_ALL_VARIANCE_REPORTS,
    labsStockManagementSagas.handleFetchAllVarianceReports
  );
  yield takeLatest(
    labsStockManagementConstants.FETCH_ONE_VARIANCE_REPORT,
    labsStockManagementSagas.handleFetchOneVarianceReport
  );
  yield takeLatest(
    labsStockManagementConstants.UPDATE_VARIANCE_REPORT,
    labsStockManagementSagas.handleUpdateVarianceReport
  );
  yield takeLatest(
    labsStockManagementConstants.ADD_VARIANCE_COMMENT,
    labsStockManagementSagas.handleAddVarianceComment
  );
  yield takeLatest(
    labsStockManagementConstants.DELETE_VARIANCE_ATTACHMENT,
    labsStockManagementSagas.handleDeleteVarianceAttachment
  );
  yield takeLatest(
    labsStockManagementConstants.FETCH_VARIANCE_HISTORY,
    labsStockManagementSagas.handleFetchVarianceHistory
  );

  // Omni Current Stock Sagas
  yield takeLatest(
    labsStockManagementConstants.FETCH_OMNI_CURRENT_STOCK,
    labsStockManagementSagas.handleFetchOmniCurrentStock
  );

  // Sync Lab Stock
  yield takeLatest(
    labsStockManagementConstants.SYNC_LAB_STOCK,
    labsStockManagementSagas.handleSyncLabStock
  );

  yield takeLatest(
    labsStockManagementConstants.FETCH_LAST_SYNC_TIME,
    labsStockManagementSagas.handleFetchLastSyncTime
  );

  // Dashboard Sagas
  yield takeLatest(
    dashboardConstants.FETCH_DASHBOARD_REGISTERS,
    dashboardSagas.handleFetchDashboardRegisters
  );

}

export function* rootSaga() {
  yield all([
    watcherSaga(),
  ]);
}
